import { AUTH_API, handleApiError } from '../../utils/axios';

export const getParts = async (search, unpaged) => {
  try {
    const url = unpaged
      ? `/api/v1/parts?search=${search.search}`
      : `/api/v1/parts?page=${search.page}&size=${search.size}&search=${search.search}`;
    const { data } = await AUTH_API.get(url);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const createPart = async (part) => {
  try {
    const { data } = await AUTH_API.post(`/api/v1/parts`, part);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const updatePart = async (part) => {
  try {
    const { data } = await AUTH_API.put(`/api/v1/parts/${part.id}`, part);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const deletePart = async (partId) => {
  try {
    const { data } = await AUTH_API.delete(`/api/v1/parts/${partId}`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};
